module.exports = __webpack_public_path__ + "img/huace13.61d9b601.jpg";